import React, { useEffect, useState, useMemo } from "react";
import UserProfile from "../../Reuseable/UserProfile..jsx";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import EvaluationService from "../../../Services/EvaluationService.js";
import UserServices from "../../../Services/UserService.js";
import DepartmentServices from "../../../Services/DepartmentServices.js";
import DataParser from "../../../utlits/Dataparser.js";
import "react-loading-skeleton/dist/skeleton.css";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import { message } from "antd";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination.jsx";
import SocketService from "../../../Services/SocketService";
import { DatePicker, Select } from "antd";
import moment from "moment";
const { RangePicker } = DatePicker;
const { Option } = Select;


const AdminEvaluationTable = ({ viewType = "team" }) => {
    const [List, setList] = useState([]);
    const [userPermissions, setuserPermissions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [dateRangeFilter, setDateRangeFilter] = useState(null);
    const [remarksModal, setRemarksModal] = useState(false);
    const [currentRemarks, setCurrentRemarks] = useState("");

    // State for View Average Report
    const [showAverageTable, setShowAverageTable] = useState(false);
    const [allCompanyUsers, setAllCompanyUsers] = useState([]);

    const [departments, setDepartments] = useState([]);
    const [deptFilter, setDeptFilter] = useState("all");
    const [userFilter, setUserFilter] = useState("all");

    // Get unique users for the modal dropdown
    const uniqueUsers = allCompanyUsers
        .map(user => ({ id: String(user.id), department_id: String(user.department_id), name: user.full_name || `${user.first_name || ""} ${user.last_name || ""}`.trim() }))
        .sort((a, b) => a.name.localeCompare(b.name));

    const tableUsers = deptFilter === "all"
        ? uniqueUsers
        : uniqueUsers.filter(u => u.department_id === String(deptFilter));

    const userImageByName = useMemo(() => {
        const map = {};
        allCompanyUsers.forEach(u => {
            const name = u.full_name || `${u.first_name || ''} ${u.last_name || ''}`.trim();
            if (name) map[name] = u.image || null;
        });
        return map;
    }, [allCompanyUsers]);

    const getUserImage = (name) => userImageByName[name] || null;

    const getAverageData = () => {
        const grouped = filteredList.reduce((acc, curr) => {
            const userId = curr.userid || curr.user_id;
            if (!acc[userId]) {
                acc[userId] = {
                    userid: userId,
                    user_name: curr.user_name,
                    attendance: 0,
                    task: 0,
                    manager: 0,
                    total: 0,
                    count: 0
                };
            }
            acc[userId].attendance += Number(curr.attendancescore || 0);
            acc[userId].task += Number(curr.taskscore || 0);
            acc[userId].manager += Number(curr.managerreviewscore || 0);
            acc[userId].total += Number(curr.totalevaluation || 0);
            acc[userId].count += 1;
            return acc;
        }, {});

        return Object.values(grouped).map(u => ({
            ...u,
            attendance: u.attendance / u.count,
            task: u.task / u.count,
            manager: u.manager / u.count,
            total: u.total / u.count
        }));
    };

    useEffect(() => {
        if (pageSize > 10) {
            setCurrentPage(1);
        }
    }, [pageSize]);

    const handelPageChange = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
    };

    const loggedUser = JSON.parse(secureLocalStorage.getItem("adminInfo"));
    const loggedUserId = loggedUser?.user?.userdata?.id;

    const getData = () => {
        setIsLoading(true);
        const companyId = DataParser.CompanyId();
        const role = DataParser.userRoleTitle() || "";
        const userId = DataParser.UserId();
        const viewAll = viewType === "all";

        EvaluationService.getallevaluation(companyId, userId, role, viewAll)
            .then((res) => {
                if (res.data === "Un-Athunticated request") {
                    message.error("Session expired! Please log in again.");
                    secureLocalStorage.removeItem("adminInfo");
                    secureLocalStorage.removeItem("admins");
                    navigate("/");
                    return;
                }

                const data = res.data.evaluations || [];
                // Sort descending to show latest evaluation period at the top
                const sortedData = data.sort((a, b) => {
                    const dateA = moment(a.periodstart, "DD MMM YYYY").valueOf();
                    const dateB = moment(b.periodstart, "DD MMM YYYY").valueOf();
                    return dateB - dateA;
                });

                setList(sortedData);
            })
            .catch((err) => {
                console.error("Error fetching list:", err);

            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchUsersData = () => {
        const companyId = DataParser.CompanyId();
        const role = DataParser.userRoleTitle() || "";
        const currentUserId = DataParser.UserId();

        UserServices.getUsernames(companyId)
            .then(res => {
                const fetchedUsers = res.data.user || [];
                // Filter out 'Company Admin' and the logged in user themselves
                const nonAdminUsers = fetchedUsers.filter(u =>
                    u.role_title?.toLowerCase() !== "company admin" && String(u.id) !== String(currentUserId)
                );

                if (viewType === "all") {
                    setAllCompanyUsers(nonAdminUsers);
                } else {
                    // For managers/heads, only show users reporting to them
                    setAllCompanyUsers(nonAdminUsers.filter(u => Number(u.report_to) === Number(currentUserId)));
                }
            })
            .catch(err => console.error("Failed to fetch users for modal", err));
    };

    const fetchDepartments = () => {
        const companyId = DataParser.CompanyId();
        if (viewType === "all") {
            DepartmentServices.getCompanyDepartment(companyId)
                .then(res => {
                    setDepartments(res.data.departments || []);
                })
                .catch(err => console.error("Failed to fetch departments", err));
        }
    };

    useEffect(() => {
        getData();
        fetchUsersData();
        fetchDepartments();
        const upermission = DataParser.CompanyUserPermissions();
        setuserPermissions(upermission);
    }, [viewType]);

    // 🟢 Socket Integration
    useEffect(() => {
        SocketService.connect();
        const companyId = DataParser.CompanyId();

        const handleEvaluationUpdate = (data) => {
            if (Number(data.company_id) === Number(companyId)) {
                console.log("🔔 Evaluation update received:", data);
                getData();
            }
        };

        SocketService.on("evaluation_update", handleEvaluationUpdate);

        return () => {
            SocketService.off("evaluation_update", handleEvaluationUpdate);
        };
    }, []);



    // Filter logic
    const getFilteredList = () => {
        let currentList = List;

        if (deptFilter !== "all") {
            currentList = currentList.filter(item => String(item.user_department) === String(deptFilter));
        }

        if (userFilter !== "all") {
            currentList = currentList.filter(item => String(item.userid) === String(userFilter));
        }

        if (!dateRangeFilter || !dateRangeFilter[0] || !dateRangeFilter[1]) {
            return currentList;
        }

        return currentList.filter(item => {
            const itemStart = moment(item.periodstart);
            const itemEnd = moment(item.periodend);
            const filterStart = dateRangeFilter[0];
            const filterEnd = dateRangeFilter[1];

            return (
                (itemStart.isSameOrAfter(filterStart, 'day') && itemStart.isSameOrBefore(filterEnd, 'day')) ||
                (itemEnd.isSameOrAfter(filterStart, 'day') && itemEnd.isSameOrBefore(filterEnd, 'day'))
            );
        });
    };

    const filteredList = getFilteredList();
    const averageData = getAverageData();
    const PaginatedData = paginate(filteredList, currentPage, pageSize);
    const paginatedAverageData = paginate(averageData, currentPage, pageSize);

    return (
        <>
            {/* <Sidebar /> */}
            <div className="main-content">
                <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="d-flex align-items-center justify-content-end" style={{ padding: "0 0 12px 0" }}>

                                    <div className="d-flex align-items-center gap-2 flex-nowrap" style={{ minWidth: 0 }}>
                                        <style>{`
                                            /* Global Filter Row Styles with float-select-wrap support */
                                            .custom-filter.float-select-wrap .ant-select-selector,
                                            .custom-filter.float-select-wrap .ant-picker {
                                                height: 34px !important;
                                                min-height: 34px !important;
                                                border-radius: 6px !important;
                                            }
                                            
                                            .custom-filter.float-select-wrap .ant-select-selection-item,
                                            .custom-filter.float-select-wrap .ant-select-selection-placeholder,
                                            .custom-filter.float-select-wrap .ant-picker-input > input {
                                                line-height: 30px !important;
                                                font-size: 13px !important;
                                            }

                                            .custom-filter.float-select-wrap label {
                                                font-size: 11px !important;
                                                font-weight: 600 !important;
                                            }

                                            .ant-picker-range .ant-picker-active-bar {
                                                background: #1D1D1D !important;
                                            }

                                            /* Hover/focus on filter fields */
                                            .custom-filter.float-select-wrap:hover .ant-select-selector,
                                            .custom-filter.float-select-wrap:focus-within .ant-select-selector {
                                                border-color: #1D1D1D !important; box-shadow: none !important;
                                            }
                                            .custom-filter.float-select-wrap:hover .ant-picker,
                                            .custom-filter.float-select-wrap .ant-picker-focused {
                                                border-color: #1D1D1D !important; box-shadow: none !important;
                                            }
                                            .custom-filter.float-select-wrap:hover label,
                                            .custom-filter.float-select-wrap:focus-within label { color: #1D1D1D !important; }
                                            .custom-filter.float-select-wrap:hover .ant-select-arrow,
                                            .custom-filter.float-select-wrap:focus-within .ant-select-arrow { color: #1D1D1D !important; }
                                            .custom-filter.float-select-wrap:hover .ant-picker-suffix div,
                                            .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div { background-color: #1D1D1D !important; }
                                            .custom-filter.float-select-wrap:hover .ant-picker-suffix div i,
                                            .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div i { color: #fff !important; }

                                            /* Table no-scroll */
                                            .listing-table { table-layout: fixed; width: 100%; min-width: 900px; }
                                            .listing-table th, .listing-table td { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
                                            .listing-table-wrapper { overflow-x: auto; }
                                            .table-body-wrapper { position: relative; }
                                            .table-loader-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.75); display: flex; align-items: center; justify-content: center; z-index: 10; min-height: 60px; }

                                            /* Buttons synchronization */
                                            .eval-action-btn {
                                                height: 34px !important;
                                                border-radius: 6px !important;
                                                font-size: 13px !important;
                                                font-weight: 600 !important;
                                                padding: 0 15px !important;
                                                display: flex !important;
                                                align-items: center !important;
                                                justify-content: center !important;
                                                box-shadow: none !important;
                                                flex-shrink: 0 !important;
                                                white-space: nowrap !important;
                                            }

                                            /* Filter inputs — fixed size, no jerk on selection */
                                            .eval-filter-shrink {
                                                flex: 0 0 160px !important;
                                                width: 160px !important;
                                                max-width: 160px !important;
                                            }
                                            .eval-date-shrink {
                                                flex: 0 0 280px !important;
                                                width: 280px !important;
                                                max-width: 280px !important;
                                            }
                                        `}</style>

                                        {viewType === "all" && (
                                            <div className={`float-select-wrap custom-filter eval-filter-shrink ${deptFilter !== "all" ? "has-value" : ""}`}>
                                                <label>Department</label>
                                                <Select
                                                    showSearch
                                                    allowClear
                                                    placeholder=""
                                                    value={deptFilter === "all" ? null : deptFilter}
                                                    onChange={(val) => {
                                                        setDeptFilter(val || "all");
                                                        setUserFilter("all");
                                                    }}
                                                    dropdownStyle={{ zIndex: 1050 }}
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                                    }
                                                >
                                                    <Option value="all" label="All">All</Option>
                                                    {departments.map(d => (
                                                        <Option key={d.id} value={String(d.id)} label={d.name}>{d.name}</Option>
                                                    ))}
                                                </Select>
                                            </div>
                                        )}

                                        <div className={`float-select-wrap custom-filter eval-filter-shrink ${userFilter !== "all" ? "has-value" : ""}`}>
                                            <label>User</label>
                                            <Select
                                                showSearch
                                                allowClear
                                                placeholder=""
                                                value={userFilter === "all" ? null : userFilter}
                                                onChange={(val) => setUserFilter(val || "all")}
                                                dropdownStyle={{ zIndex: 1050 }}
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                                }
                                            >
                                                <Option value="all" label="All">All</Option>
                                                {tableUsers.map(u => (
                                                    <Option key={u.id} value={String(u.id)} label={u.name}>{u.name}</Option>
                                                ))}
                                            </Select>
                                        </div>

                                        <div className={`float-select-wrap custom-filter eval-date-shrink ${(dateRangeFilter && dateRangeFilter.length > 0) ? "has-value" : ""}`}>
                                            <label>Evaluation Period</label>
                                            <RangePicker
                                                onChange={(dates) => setDateRangeFilter(dates)}
                                                value={dateRangeFilter}
                                                allowClear
                                                separator=""
                                                placeholder={['', '']}
                                                suffixIcon={
                                                    <div style={{
                                                        backgroundColor: "#F4F4F4",
                                                        borderRadius: "6px",
                                                        width: "24px",
                                                        height: "24px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginRight: "-4px"
                                                    }}>
                                                        <i className="uil-schedule" style={{ color: "#A0A0A0", fontSize: "15px" }} />
                                                    </div>
                                                }
                                            />
                                        </div>
                                        {showAverageTable ? (
                                            <button
                                                className="btn btn-outline-danger eval-action-btn"
                                                onClick={() => setShowAverageTable(false)}
                                            >
                                                <i className="uil-sync me-1"></i> Reset to List
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-success eval-action-btn"
                                                style={{
                                                    backgroundColor: "#0DDFAB",
                                                    borderColor: "#0DDFAB",
                                                    color: "#fff"
                                                }}
                                                onClick={() => {
                                                    setShowAverageTable(true);
                                                    setCurrentPage(1);
                                                }}
                                            >
                                                View Average Report
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 px-0">
                                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                                    <div className="card-body p-0">
                                        <div className="listing-table-wrapper">
                                            <table className="table mb-0 custom-table listing-table">
                                                <thead>
                                                    <tr className="tableHeaderbg text-start">
                                                        <th className="text-start">Name</th>
                                                        {!showAverageTable && (
                                                            <>
                                                                <th className="text-start">Attendance Score</th>
                                                                <th className="text-start">Task Score</th>
                                                                <th className="text-start">Manager Review Score</th>
                                                            </>
                                                        )}
                                                        <th className="text-start">Total Score</th>
                                                        {!showAverageTable && (
                                                            <>
                                                                <th className="text-start">Evaluation Period</th>
                                                                <th className="text-start">Evaluated By</th>
                                                                <th className="text-start">Remarks</th>
                                                            </>
                                                        )}
                                                        {showAverageTable && <th className="text-start">Evaluations Count</th>}
                                                    </tr>
                                                </thead>
                                            </table>
                                            <div className="table-body-wrapper">
                                                <table className="table mb-0 custom-table listing-table">
                                                    <tbody>
                                                        {isLoading ? <TableSkeleton cols={8} rows={6} /> : (
                                                            <>
                                                                {showAverageTable ? (
                                                                    <>
                                                                        {paginatedAverageData && paginatedAverageData.length > 0 ? (
                                                                            paginatedAverageData.map((item) => (
                                                                                <tr key={item.userid} className="text-start">
                                                                                    <td className="tableset">
                                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                            <UserProfile username={item.user_name} userImage={getUserImage(item.user_name)} style={{ width: '22px', height: '22px' }} />
                                                                                            <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500' }}>{item.user_name}</span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="tableset">
                                                                                        <span className="badge bg-success" style={{ fontSize: "14px", padding: "6px 12px" }}>
                                                                                            {Number(item.total || 0).toFixed(2)}%
                                                                                        </span>
                                                                                    </td>
                                                                                    <td className="tableset">
                                                                                        {item.count} evaluation{item.count > 1 ? 's' : ''}
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr><td colSpan="12" className="text-center">No evaluation data found for averages.</td></tr>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {PaginatedData && PaginatedData.length > 0 ? (
                                                                            PaginatedData.map((item, index) => (
                                                                                <tr key={item.id} className="text-start">
                                                                                    <td className="tableset">
                                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                            <UserProfile username={item.user_name} userImage={getUserImage(item.user_name)} style={{ width: '22px', height: '22px' }} />
                                                                                            <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500' }}>{item.user_name}</span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="tableset">{Number(item.attendancescore || 0).toFixed(2)}%</td>
                                                                                    <td className="tableset">{Number(item.taskscore || 0).toFixed(2)}%</td>
                                                                                    <td className="tableset">{Number(item.managerreviewscore || 0).toFixed(2)}%</td>
                                                                                    <td className="tableset">{Number(item.totalevaluation || 0).toFixed(2)}%</td>
                                                                                    <td className="tableset">{item.periodstart} - {item.periodend}</td>
                                                                                    <td className="tableset">
                                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                            <UserProfile username={item.evaluationby_name} userImage={getUserImage(item.evaluationby_name)} style={{ width: '22px', height: '22px' }} />
                                                                                            <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500' }}>{item.evaluationby_name}</span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="tableset">
                                                                                        <button className="btn btn-sm" onClick={() => { setCurrentRemarks(item.remarks || "No remarks provided."); setRemarksModal(true); }}>
                                                                                            <i className="uil-eye" style={{ fontSize: "16px" }}></i>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr><td colSpan="12" className="text-center">No Performance Evaluation found.</td></tr>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {(showAverageTable ? averageData.length : filteredList.length) > pageSize && (
                                                <div className="d-flex justify-content-center mt-4">
                                                    <Pagination
                                                        itemCount={showAverageTable ? averageData.length : filteredList.length}
                                                        currentPage={currentPage}
                                                        pageSize={pageSize}
                                                        onPageChange={handelPageChange}
                                                    />
                                                </div>
                                            )}
                                        </div>


                                        {/* Remarks Modal */}
                                        {remarksModal && (
                                            <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1055 }} tabIndex="-1" onClick={() => setRemarksModal(false)}>
                                                <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                                                    <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "12px" }}>
                                                        <div className="modal-header border-0 pb-0">
                                                            <h5 className="modal-title fw-bold" style={{ color: "#0f223a" }}>Remarks</h5>
                                                            <button type="button" className="btn-close" onClick={() => setRemarksModal(false)}></button>
                                                        </div>
                                                        <div className="modal-body p-4 text-center">
                                                            <div className="mb-4">
                                                                <p className="text-muted mb-0" style={{ fontSize: "15px", lineHeight: "1.6" }}>
                                                                    {currentRemarks}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminEvaluationTable;
